// *** RETIRED 04/10/26 - Founder order: designs cancelled, 3D pages instead. Every visitor = control (or the x3d journey);
// cookies ex_arm/ex_arm_p/ex_absim are IGNORED and expired by middleware abDecide(); ?layout=/&ab=set do nothing; resolveTopicLayout() returns null.
// The rules below are HISTORICAL. Analytics columns ab_arm/visitor_id stay (values now only 'c'/'amp'). ***
// THE A/B design door (Founder order 02/10/26: "שהמשתמשים יקבלו את זה רנדומלית כמעין A/B Testing … משתמש שקיבל עיצוב X ממשיך
// לקבל X כל הביקור"). Edge-safe (middleware imports it): pure constants + functions, no node APIs, no DB.
//
// Arms: 'c' = CONTROL (today's production look) + the 3.x family (bezalel spec, lib/topicLayout.ts SPECS). Equal weights.
// Assignment happens ONCE, server-side in middleware.ts, before the first paint (cookie ex_arm, 30 days):
//   ?layout=<arm>  → PREVIEW: session cookie ex_arm_p (sticky while browsing, logged 'p:<arm>', excluded from results);
//                    ?layout=off clears it; &ab=set writes the real ex_arm instead (QA/Nathan opt-in).
//   ex_arm cookie  → that arm (sticky 30 days).
//   crawler        → control, no cookie (lib/crawler.ts).
//   AB_LIVE, or the simulation cookie ex_absim=1 → random equal pick + cookie.
//   otherwise      → control with NO cookie (pre-live: a real visitor stays unassigned, so going live randomizes him fresh).
// Every analytics row stores ab_arm + visitor_id (lib/abServer.ts abFromRequest — the one server reader).
// AMP twins are NOT in the test: AMP is a separate renderer and keeps control (every-surface-amp-law, documented 02/10/26).

/** LIVE since 02/10/26 (Founder: "יש לנו תנועה אמיתית… שזה באמת יעבוד כמו שצריך") — equal split until he says otherwise.
 *  false = everyone control, no arm cookie (the pre-live state). Own traffic + crawlers stay control (middleware.ts). */
export const AB_LIVE = false as boolean; // RETIRED 04/10/26 (Founder: designs cancelled, 3D pages instead). Nothing assigns arms any more; middleware abDecide() is hard-wired to control. Do NOT flip.
export const AB_VERSION = 'v1';                      // bump to re-randomize everyone (old cookies are then ignored)
export const ARMS = ['c', '3.1', '3.2', '3.3', '3.4', '3.5', '3.6'] as const;
export type Arm = (typeof ARMS)[number];
export const ARM_NAMES: Record<Arm, string> = {
  c: 'ביקורת (העיצוב הנוכחי)', '3.1': 'הגיליון', '3.2': 'היום', '3.3': 'אהובי הלקוחות', '3.4': 'המיון', '3.5': 'הגיליון הנשלף', '3.6': 'מכתבים',
};
/** equal split by default (open decision for Nathan: traffic split %) */
export const ARM_WEIGHTS: Record<Arm, number> = { c: 1, '3.1': 1, '3.2': 1, '3.3': 1, '3.4': 1, '3.5': 1, '3.6': 1 };

export const AB_COOKIE = 'ex_arm';                   // "v1.3.4"
export const AB_PREVIEW_COOKIE = 'ex_arm_p';         // session cookie, preview only
export const AB_SIM_COOKIE = 'ex_absim';             // "1" = simulation visitor (pre-live random assignment, QA UA → is_test)
export const VISITOR_COOKIE = 'ex_vid';              // "v_<base36 time><random>" 30 days
export const AB_MAX_AGE = 30 * 24 * 3600;
export const AB_HEADER = 'x-ab-arm';                 // request header middleware → server components
export const AB_SRC_HEADER = 'x-ab-src';             // cookie | new | preview | crawler | default
export const VISITOR_HEADER = 'x-ab-vid';

export const isArm = (v: unknown): v is Arm => typeof v === 'string' && (ARMS as readonly string[]).includes(v);

export function parseArmCookie(v: string | undefined | null): Arm | null {
  if (!v) return null;
  const [ver, ...rest] = v.split('.');
  const arm = rest.join('.');
  return ver === AB_VERSION && isArm(arm) ? arm : null;
}
export const armCookieValue = (arm: Arm) => `${AB_VERSION}.${arm}`;

/** weighted pick; r ∈ [0,1) (crypto random in middleware, injectable for tests) */
export function pickArm(r: number): Arm {
  const total = ARMS.reduce((s, a) => s + ARM_WEIGHTS[a], 0);
  let x = r * total;
  for (const a of ARMS) { x -= ARM_WEIGHTS[a]; if (x < 0) return a; }
  return 'c';
}

export function newVisitorId(rand: string): string {
  return `v_${Date.now().toString(36)}${rand}`.slice(0, 40);
}
export const isVisitorId = (v: unknown): v is string => typeof v === 'string' && /^v_[a-z0-9]{6,38}$/.test(v);

/** the value stored in analytics ab_arm: a real arm, or 'p:<arm>' for a preview view (never counted in results) */
export function analyticsArm(arm: string | null | undefined, src: string | null | undefined): string | null {
  if (!isArm(arm)) return null;
  return src === 'preview' ? `p:${arm}` : arm;
}
